<!-- <button pButton type="button" class="p-button-rounded">A</button> -->
<div class="accountsIcon img-border-container" (click)="toggleIconClick()" [ngStyle]="{'background-image': 'url(' + icon + ')'}">
  <div class="img-border-image" >
    <span *ngIf="!icon">{{name}}</span>
  </div>
</div>
